import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { Utilities } from 'src/app/constants/utilities';
import { ServicecallService, SubmitButtonClickService } from 'src/app/services';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { FileHandle } from 'src/app/shared/directives/drag.directive';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit, OnDestroy {

  @Input() tenantList: any;
  registrationForm: FormGroup;
  regSubmitted: boolean = false;
  regErrorMessage: any = null;
  imgURL: any = null;
  userId: any = null;
  private _loading: boolean = false;
  private _imageFile: any;
  private _sasUrl: any = null;
  private _thumbnail: any = null;  
  private _registerUserSubscription: Subscription;
  private _afterClosedSubscription: Subscription;
  private _updateImageSubscription: Subscription;
  
  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private _service: ServicecallService,
    private _datepipe: DatePipe,
    private _cd: ChangeDetectorRef,
    private _submitButtonClick: SubmitButtonClickService,
    private _submitButtonSuccess: SubmitButtonClickService,
    private _dialog: MatDialog
  ) {
    this.registrationForm = this._fb.group({
      image: [],
      name: [],
      organisation: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      empId: [],
      personalInfo: [],
      contact: [],
      comment: []
    });
  }

  ngOnInit(): void {
    this.userId = localStorage.getItem('userId') ? localStorage.getItem('userId') : null;
    // this.getTenant();
  }
  ngOnDestroy(): void {
    this._registerUserSubscription?.unsubscribe();
    this._afterClosedSubscription?.unsubscribe();  
    this._updateImageSubscription?.unsubscribe();  
  }
  reset() {
    this.regSubmitted = false;
    this.regErrorMessage = null;
    this._loading = false;
    this._sasUrl = null
    this._thumbnail = null;
    this.imgURL = null
    this._submitButtonSuccess.setSubmitButtonSuccess('success');
    this.registrationForm.reset();
  }

  /* Signup button click */
  signup() {
    this._submitButtonClick.setSubmitButtonClick('clicked');
    this._loading = true;
    this.regSubmitted = true;
    this.regErrorMessage = null;
    if (this.registrationForm.invalid) {
      this._loading = false;
      return;
    }
    if (this._imageFile) {
      this._imageUpload(null, null, this._imageFile, null, false);
    } else {
      this._registerUser();
    }
  }

  /* File upload */
  filesDropped(files: FileHandle[]): void {
    if (files.length !== 0) {
      this.onImageSelected(files[0].file, true);
    }
  }
  onImageSelected(event: any, dropped?: any) {

    // this._sasUrl = null;
    this._thumbnail = null;
    // let img: File;
    const file = dropped ? event : event.target.files[0];
    if (file.type.includes('image/')) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imgURL = reader.result;
      };
      // img = event.target.files[0]
      this._imageFile = file;
      // this.imageUpload(null, null, img, null, false)
      this._cd.markForCheck();
    } else {
      this._imageFile = null;
      this._service.toasterService({ type: Messages.ERROR, msg: 'Please upload any valid image type' });
      return;
    }
  }
   /* Delete image */
   deleteImage() {
    this.registrationForm.patchValue({ image: null });
    this._imageFile = null;
    this.imgURL = null;
  }

  /* Login redirection */
  logIn() {
    if (this.userId)
      this._router.navigateByUrl(this._service.getPrivilegeUrl());
    else
      this._router.navigateByUrl('login');
  }

  /* Form values */
  get regFormValues() {
    return this.registrationForm.controls;
  }

  /* Tenant Details list */
  // getTenant() {
  //   this.loading = true;
  //   this._service.getTenantDetails().subscribe((res: any) => {
  //     if (res['status']) {
  //       if (res['response'] && res['response']['response'].length > 0) {
  //         this.tenantList = res['response']['response'];
  //       }
  //       this.loading = false;
  //     } else {
  //       this.loading = false;
  //     }
  //   });
  // }

  /* Register user */
  private _registerUser() {
    if (this.registrationForm.value.organisation) {
      let tenant = this.tenantList.find((x: any) => (x.domain).toLowerCase() === this.registrationForm.value.organisation.toLowerCase())
      if (tenant) {
        localStorage.setItem("tenantId", tenant['_id']);
        let currentTime = Utilities.getCurrentTimeFormat();
        const dob = this.registrationForm.value.personalInfo?.dob ? this._datepipe.transform(this.registrationForm.value.personalInfo.dob, 'yyyy-MM-dd') : '';
        let userDetails: any = {
          "tenantId": tenant['_id'],
          "organisation": this.registrationForm.value.organisation,
          "name": {
            "first": this.registrationForm.value.name.firstName,
            "middle": this.registrationForm.value.name?.middleName,
            "last": this.registrationForm.value.name.lastName,
          },
          "empId": this.registrationForm.value.empId,
          "phone": {
            "country": this.registrationForm.value.contact?.number ? this.registrationForm.value.contact?.number?.countryCode : 'IN',
            "countryCode": this.registrationForm.value.contact?.number?.dialCode,
            "number": this.registrationForm.value.contact?.number?.number,
          },
          "personal": {
            "bloodGroup": this.registrationForm.value.personalInfo?.bloodGroup,
            "nationality": this.registrationForm.value.personalInfo?.nationality,
            "dob": dob,
            "gender": this.registrationForm.value.personalInfo?.gender,
          },
          "email": this.registrationForm.value.contact?.email,
          "image": this.registrationForm.value.image,
          "thumbnail": null,
          "userComments": this.registrationForm.value.comment
        }

        let set: any = {
          userDetails: userDetails,
          sourceTime: currentTime
        }
        this._registerUserSubscription = this._service.registerUser(set).subscribe((result: any) => {
          if (result['status']) {
            if (result['response']) {
              this._submitButtonSuccess.setSubmitButtonSuccess('success');
              // window.alert(Messages.REGISTRATION + Messages.SIGNUP_SUCCESS);
              let dialogRef = this._dialog.open(AlertDialogComponent, {
                data: { msg: Messages.REGISTRATION + ' ' + Messages.SIGNUP_SUCCESS, type: 'hideCancel' },
                disableClose: true
              });
              this._afterClosedSubscription = dialogRef.afterClosed().subscribe(res => {
                if (res) {
                  this.regSubmitted = false;
                  this._loading = false;
                  this._sasUrl = null;
                  this._thumbnail = null;
                  this.imgURL = null;
                  this.registrationForm.reset();
                }
              });
            }
            else {
              this._loading = false;
              this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
              this.regSubmitted = false;
            }
          }
          else {
            this._loading = false;
            this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
            this.regSubmitted = false;
          }

        });
      }
      else {
        this._loading = false;
        this.regErrorMessage = Messages.INVALID_ORG;
      }
    }
  }

  /* Reset form */
  

  /* Image upload service */
  private _imageUpload(relativePath: any, type: any, img: any, recordId: any, del?: any) {
    this._updateImageSubscription = this._service.updateImage(relativePath, type, img, recordId).subscribe((res: any) => {
      if (res['status']) {
        this.registrationForm.value.image = null;
        this.imgURL = null;
        if (!del) {
          if (res['response']['sasUrl']) {
            this._sasUrl = res['response']['sasUrl'];
            this.registrationForm.patchValue({ image: this._sasUrl })
            this.imgURL = this._sasUrl
          }
          if (res['response']['thumbnail']) {
            this._thumbnail = res['response']['thumbnail']
          }
        }
        else {
          this._sasUrl = null
          this._thumbnail = null
          this.imgURL = null
          this.registrationForm.patchValue({ image: this._sasUrl });
        }
      } else {
        this.imgURL = null;
        this._sasUrl = null
        this._thumbnail = null;
      }
      this._registerUser();
    })
  }

  // deleteImage() {
  //   let relativePath: any;
  //   let recordId: any;
  //   let type: any;
  //   if (typeof (this.registrationForm.value.image) === 'string') {
  //     let image = this.registrationForm.value.image;
  //     if (this._sasUrl == null) {
  //       relativePath = image.split("?")[0].split("/").pop()
  //     }
  //     else {
  //       type = null;
  //       relativePath = this._sasUrl.split("?")[0].split("/").pop();
  //     }
  //   }
  //   else {
  //     this.registrationForm.value.image = null;
  //     this.imgURL = null;
  //   }
  //   this.imageUpload(relativePath, type, null, recordId, true);
  // }

  /* Launch page redirection */
  private _navigateToLaunch() {
    this._router.navigate(['/login']);
  } 

}
